import { round } from "lodash";
import { Benchmark } from "../../hooks";
import { CircularProgress } from "../PercentageCircle";
import { PerformanceSummary } from "../PerformanceSummary";
import { useTranslation } from "react-i18next";
import "./style.scss";

export const ScoreBenchmarkOverview = ({
  isCategoryPage,
  score,
  selectedBenchmark,
  benchmarks,
  setSelectedBenchmark,
}: {
  isCategoryPage?: boolean;
  score: number;
  selectedBenchmark?: Benchmark;
  benchmarks: Benchmark[];
  setSelectedBenchmark: (benchmark: Benchmark) => void;
}) => {
  const { t } = useTranslation();
  const benchmarkValue = (selectedBenchmark?.value ?? 0) * 100;
  const roundedDifference = round(score - benchmarkValue, 0);
  const circleValue =
    roundedDifference > 0 ? `+${roundedDifference}` : roundedDifference;
  const circularProgress = <CircularProgress centerValue={`${circleValue}%`} />;
  return (
    <div className="score-benchmark-overview">
      {isCategoryPage && circularProgress}
      <PerformanceSummary
        title={t("frontend.futurebilityCockpit.score", "Score")}
        subtitle={t("frontend.futurebilityCockpit.average", "Average")}
        result={round(score, 0)}
      />
      <PerformanceSummary
        title={t("frontend.futurebilityCockpit.benchmark", "Benchmark")}
        subtitle={selectedBenchmark?.title || "N/A"}
        result={round(benchmarkValue, 0)}
        dropdownItems={benchmarks}
        onSelectItem={setSelectedBenchmark}
        selectedItem={selectedBenchmark}
        disableParentSelecting
      />
      {!isCategoryPage && circularProgress}
    </div>
  );
};
